import { Button } from '@/components';
import { ButtonProps } from '@/components/atoms/Button/Button';
import { URLS } from '@/utils/constants';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { GiGrowth } from 'react-icons/gi';
const EarnIcon = GiGrowth as React.ComponentType<any>;
const EarnButton: FC<ButtonProps> = (props) => {
  const router = useRouter();
  const handleSeeAllYieldBearingAssets = () => {
    router.push(URLS.allYieldBearingAssets);
  };
  return (
    <Button
      icon={<EarnIcon className="text-accent" />}
      iconStyles={{ intent: 'accent' }}
      onClick={handleSeeAllYieldBearingAssets}
      {...props}
    >
      Earn
    </Button>
  );
};
export default EarnButton;
